import { privateRouteList, publicRouteList, registerRouteList } from '../routes';

export function getObservabilityRoutePatterns() {
  return [...privateRouteList, ...publicRouteList, ...registerRouteList]
    .map(route => route.path)
    .filter(Boolean);
}
